// ElegantImageTextSection.jsx
import React from "react";
import {
  Box,
  Typography,
  Grid2,
  useTheme,
  Paper,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";
import { sort_data } from "./Helper";

/**
 * Props:
 * - image: string (URL)
 * - title: string
 * - subtitle: string
 * - description: string
 * - align: 'left' | 'right' (image side)
 * - buttonText?: string
 * - onButtonClick?: () => void
 */
export default function ElegantImageTextSection({
  align = "left"
}) {
  const theme = useTheme();

  const isLeft = align === "left";
  return (
    <>
      {sort_data.map((item, index) => {
        return (
          <Paper
            elevation={2}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              mt: 4,
            }}
          >
            <Grid2
              container
              direction={(index % 2) === 1 ? "row" : "row-reverse"}
              spacing={0}
              sx={{
                alignItems: "stretch",
                minHeight: 600,
              }}
            >
              {/* Image */}
              <Grid2
                item
                size={{ xs: 12, md: 8 }}
                component={motion.div}
                initial={{ opacity: 0, x: isLeft ? -40 : 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
              >
                <Box
                  sx={{
                    height: "100%",
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    [theme.breakpoints.down("md")]: {
                      minHeight: 340,
                    },
                  }}
                />
              </Grid2>

              {/* Text Section */}
              <Grid2
                item
                size={{ xs: 12, md: 4 }}
                component={motion.div}
                initial={{ opacity: 0, x: isLeft ? 40 : -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
              >
                <Box
                  sx={{
                    p: { xs: 3, md: 6 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  {item.subtitle && (
                    <Typography
                      variant="overline"
                      color="warning"
                      sx={{ fontWeight: 600, mb: 1 }}
                    >
                      {item.subtitle}
                    </Typography>
                  )}
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 3, lineHeight: 1.7 }}
                  >
                    {item.description}
                  </Typography>
                </Box>
              </Grid2>
            </Grid2>
          </Paper>
        )
      })}
    </>
  );
}